import {
  formatPrice,
  priceFormatedObject,
  validatePrice,
} from '@/utils/category';

export const calcCartTotalHandler = (items = []) => {
  return items?.reduce((cur, acc) => {
    const price = validatePrice(priceFormatedObject(acc));
    return (
      cur + ((price?.specialPrice || price?.originalPrice) * acc?.qty || 0)
    );
  }, 0);
};

export const calcTotals = (items = []) => {
  const totals = items.reduce(
    (acc, curr) => {
      const qty = curr?.qty || 0;
      const price = curr?.price || 0;
      const priceWithTax =
        curr?.prices_with_tax?.price || curr?.price_incl_tax || 0;

      acc.subtotal += price * qty;
      acc.tax += (priceWithTax - price) * qty;

      return acc;
    },
    { subtotal: 0, tax: 0 }
  );

  const formattedSubtotal = formatPrice(totals.subtotal);
  const formattedTax = formatPrice(totals.tax);
  const formattedTotalWithTax = formatPrice(totals.subtotal + totals.tax);

  return [
    {
      code: 'subtotal',
      title: 'Subtotal',
      value: formattedSubtotal,
    },
    {
      code: 'tax',
      title: 'Tax',
      value: formattedTax,
    },
    {
      code: 'grand_total',
      title: 'Grand Total',
      value: formattedTotalWithTax,
    },
  ];
};
